import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/newLootkaFont.webp";

const NavbarBrand = () => {
  const { pathname } = useLocation();
  const showTagline = pathname !== "/";

  return (
    <Link
      to="/"
      aria-label="لوتکا، صفحه اصلی"
      className="flex flex-col items-end justify-center text-right"
    >
      <img
        src={logo}
        alt="لوتکا"
        className="h-9 w-auto object-contain desktop:h-12"
      />
      {showTagline && (
        <span className="whitespace-nowrap text-[9px] leading-3 text-gray-500 font-myYekanMedium tablet:text-[10px]">
          اولین پلتفرم بومی سفر به شمال ایران
        </span>
      )}
    </Link>
  );
};

export default NavbarBrand;
